export default __webpack_public_path__ + "static/media/past.bae2225c.svg";